import React from "react";
import psdalogo from "../asset/PSDA-logo2.png";

const Clients = () => {

    const clients = [
        {
            logo: psdalogo,
            name: "Perfect Screen Dance Academy",
            description:
                "A leading dance academy using our platform for batch management, fee tracking, parent communication, and secure online payments.",
            link: "http://www.perfectscreendanceacademy.in",
        }
    ];

    return (
        <section id="clients" className="features clients">
            <div className="container">
                <div className="section-header">
                    <h2>Our Happy Clients</h2>
                    <p>Trusted by dance academies across India</p>
                </div>

                <div className="clients-grid">
                    {clients.map((client, index) => (
                        <div key={index} className="feature-card">
                            <div className="client-icon">
                                <img
                                    src={client.logo}
                                    alt={client.name}
                                    className="client-logo"
                                />
                            </div>


                            <h3>{client.name}</h3>
                            <p>{client.description}</p>

                            <a
                                href={client.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="client-link"
                            >
                                Visit Website →
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>

    );
};

export default Clients;
